import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DollarSign, TrendingUp } from 'lucide-react';

interface SubscriptionSummaryCardProps {
  totalMRR: number;
  totalARR: number;
  activeCount: number;
}

export function SubscriptionSummaryCard({ totalMRR, totalARR, activeCount }: SubscriptionSummaryCardProps) {
  return (
    <div className="grid gap-4 md:grid-cols-3">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Monthly Recurring Revenue</CardTitle>
          <DollarSign className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">${totalMRR.toFixed(2)}</div>
          <p className="text-xs text-muted-foreground">{activeCount} active subscriptions</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Annual Recurring Revenue</CardTitle>
          <TrendingUp className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">${totalARR.toFixed(2)}</div>
          <p className="text-xs text-muted-foreground">Projected annual revenue</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Average per Tenant</CardTitle>
          <DollarSign className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            ${activeCount > 0 ? (totalMRR / activeCount).toFixed(2) : '0.00'}
          </div>
          <p className="text-xs text-muted-foreground">Monthly average</p>
        </CardContent>
      </Card>
    </div>
  );
}
